import { useEffect, useState } from "react";
import { Input, InputProps } from "./Input";

export const PhoneInput = (
  props: Omit<InputProps, "onChange"> & {
    onChange?: (value: string) => void;
  }
) => {
  const { value, onChange, ...rest } = props;
  const [internalValue, setInternalValue] = useState<string>();

  useEffect(() => {
    setInternalValue(maskPhoneNumber(value as string));
  }, [value]);

  function extractNumbers(inputString: string): string {
    if (!inputString) return inputString;

    const matches = inputString.match(/\d/g);

    if (!matches) {
      return "";
    }

    return matches.join("");
  }

  function maskPhoneNumber(phone: string | undefined): string | undefined {
    if (!phone) return phone;

    const number = extractNumbers(phone);
    if (number.length > 10) return number;

    let masked = "";

    if (number.length >= 0) masked = number;
    if (number.length > 3) masked = `${number.substring(0, 3)}-${number.substring(3, 6)}`;
    if (number.length > 6) masked = `${masked}-${number.substring(6, 10)}`;

    return masked;
  }

  return (
    <>
      {/* {value} */}
      <Input onChange={(e) => onChange?.(extractNumbers(e.target.value))} value={internalValue} {...rest} />
    </>
  );
};
